<template>
    <popup-modal
        @close="$emit('close')"
        custom-classes="w-600"
        position="center"
        :title="$t('applications.assessments.request')"
    >
        <div class="w-full flex flex-col items-center mb-24">

            <img src="/app/img/copreno-logo.png" alt="Copreno logo" class="mb-24 w-1/3">

            <p class="mb-24" v-html="$t('applications.assessments.description')"></p>

            <div class="p-16 rounded mb-16 border border-semantic-warning bg-semantic-warning-light text-semantic-warning-dark">
                <p>{{ $t('applications.assessments.lang_warning') }}</p>
            </div>
        </div>

        <div class="flex justify-end">
            <simple-button
                display="secondary"
                :loading="submitting"
                look="primary"
                @click="submit"
            >
                {{ $t('applications.assessments.send', {applicant: application.first_name})}}
            </simple-button>
        </div>
    </popup-modal>
</template>

<script>
import Application from '../../models/Application';
import PopupModal from './PopupModal.vue';
import {mapActions} from 'pinia';
import {useNotificationsStore} from '../../state/modules/notifications';
import SimpleButton from './SimpleButton.vue';
import * as applications from '../../services/ApplicationService';
import { ADD_NOTIFICATION } from '../../state/mutation-types';


export default {
    components: {
        'popup-modal': PopupModal,
        'simple-button': SimpleButton,
    },
    props: {
        application: Application
    },
    data: function () {
        return {
            submitting: false,
            resultMessage: null,
        }
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        submit () {
            this.submitting = true;

            applications.requestAssessment(this.application.id)
                .then(response => {
                    this[ADD_NOTIFICATION]({
                        type: 'success',
                        message: this.$t('applications.assessments.success'),
                    });
                })
                .finally(() => {
                    this.submitting = false;
                    this.$emit('close');
                });
        }
    }
}
</script>
